import React from "react";
import { Check } from "lucide-react";

/**
 * Shared cell used by ComparisonTable.
 * Accepts a `value` of:
 *  - `true`  → orange filled circle with white check (highlighted col) or orange-tinted circle with orange check
 *  - `false` → subtle dash rule
 *  - `string` → uppercase kerning text (orange when highlighted)
 */
export default function ComparisonCell({ value, highlight = false }) {
  let content;
  if (value === true) {
    content = (
      <span
        className={`inline-grid place-items-center w-8 h-8 rounded-full ${
          highlight
            ? "bg-liftile-orange text-white"
            : "bg-liftile-orange/15 text-liftile-orange"
        }`}
      >
        <Check className="w-4 h-4" strokeWidth={3} />
      </span>
    );
  } else if (value === false) {
    content = (
      <span className="inline-block w-6 h-px bg-liftile-matte-black/25" />
    );
  } else {
    content = (
      <span
        className={`font-heading text-[11px] md:text-xs uppercase tracking-[0.18em] font-semibold ${
          highlight ? "text-liftile-orange" : "text-liftile-matte-black/75"
        }`}
      >
        {value}
      </span>
    );
  }
  return (
    <td
      className={`text-center px-5 md:px-7 py-4 md:py-5 align-middle border-l border-liftile-matte-black/[0.06] ${
        highlight ? "bg-liftile-orange/[0.05]" : ""
      }`}
    >
      {content}
    </td>
  );
}
